import { countryMap } from '../../../../../../../helpers/country';
import { isValidPhone, isValidEmail } from '../../../../../../../helpers/regexp';
import { validate } from '../../../../../../../helpers/validate';
import { useLang } from '../../../../../../../hooks/use-lang';
import { useManagerStore } from '../../../../../../../store/use-manager-store';
import { IdValue } from '../../../../../../../types/props';

export const useProfilePersonal = () => {
  const { managerProfile, handleUpdateManagerProfile, handleSaveManagerProfile, saveManagerProfile } =
    useManagerStore();
  const { t } = useLang();

  const countryResponse = managerProfile?.country;

  const handleSubmit = () => {
    const isValid = validate({
      surname: { rule: () => !!managerProfile?.last_name },
      name: { rule: () => !!managerProfile?.first_name },
      region: { rule: () => !!managerProfile?.area },
      city: { rule: () => !!managerProfile?.city },
      phone: { rule: () => isValidPhone(managerProfile?.phone) },
      email: { rule: () => isValidEmail(managerProfile?.email) },
    });

    const isChanged = JSON.stringify(saveManagerProfile) !== JSON.stringify(managerProfile);
    if (!isValid || !isChanged) return;
    handleSaveManagerProfile();
  };

  const handleChangeCountry = (e: IdValue) => {
    handleUpdateManagerProfile({ country: e.id });
    handleSaveManagerProfile();
  };

  return {
    firstname: managerProfile?.first_name,
    secondname: managerProfile?.second_name,
    lastname: managerProfile?.last_name,
    country: countryResponse
      ? {
          id: countryResponse,
          value: countryMap[countryResponse],
        }
      : undefined,
    region: managerProfile?.area,
    city: managerProfile?.city,
    phone: managerProfile?.phone,
    email: managerProfile?.email,
    handleUpdateManagerProfile,
    t,
    handleSubmit,
    handleChangeCountry,
  };
};
